const getRoute = (pathname: string): string => {
  const homes = /homes/;
  const users = /users/;
  const raffles = /raffles/;
  const winners = /winners/;
  const dreamHome = /dreamHome/;
  const lifeStylePrizes = /prizes/;
  const prizes = /fixedOdds/;
  const weeklySubscriptionDraws = /weeklySubscriptionDraws/;
  const affiliates = /affiliates/;
  const affiliateUsers = /affiliateUsers/;
  const staffUsers = /staffUsers/;
  const competitions = /competitions/;
  const general = /general/;
  const winGeneral = /win-general/;
  const discountGeneral = /discount-general/;
  const dealGeneral = /deal-general/;
  const offerGeneral = /offer-general/;
  const referrals = /referrals/;
  const specialOffers = /specialOffers/;
  const reports = /reports/;
  const blogs = /blogs/;
  const bonusDraws = /bonusDraws/;
  const generalContent = /content/;

  if (homes.test(pathname)) {
    return 'homes';
  }
  if (users.test(pathname)) {
    return 'users';
  }
  if (raffles.test(pathname)) {
    return 'raffles';
  }
  if (winners.test(pathname)) {
    return 'winners';
  }
  if (dreamHome.test(pathname)) {
    return 'dreamHome';
  }
  if (weeklySubscriptionDraws.test(pathname)) {
    return 'weeklySubscriptionDraws';
  }
  if (lifeStylePrizes.test(pathname)) {
    return 'prizes';
  }
  if (prizes.test(pathname)) {
    return 'fixedOdds';
  }
  if (affiliates.test(pathname)) {
    return 'affiliates';
  }
  if (affiliateUsers.test(pathname)) {
    return 'affiliateUsers';
  }
  if (staffUsers.test(pathname)) {
    return 'staffUsers';
  }
  if (competitions.test(pathname)) {
    return 'competitions';
  }

  if (winGeneral.test(pathname)) {
    return 'win-general';
  }
  if (discountGeneral.test(pathname)) {
    return 'discount-general';
  }
  if (dealGeneral.test(pathname)) {
    return 'deal-general';
  }
  if (offerGeneral.test(pathname)) {
    return 'offer-general';
  }
  if (general.test(pathname)) {
    return 'thesun-general';
  }
  if (general.test(pathname)) {
    return 'general';
  }
  if (referrals.test(pathname)) {
    return 'referrals';
  }
  if (specialOffers.test(pathname)) {
    return 'specialOffers';
  }
  if (reports.test(pathname)) {
    return 'reports';
  }
  if (blogs.test(pathname)) {
    return 'blogs';
  }
  if (bonusDraws.test(pathname)) {
    return 'bonusDraws';
  }
  if (generalContent.test(pathname)) {
    return 'generalContent';
  }
  return 'other';
};

export default getRoute;
